import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconGuest = ({ id, color, width = 40, style, ...restProps }: IProps) => {
  const viewBoxWidth = 40;
  const viewBoxHeight = 46;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        fillRule="evenodd"
        d="M28.68 25.695c6.242 0 11.32 5.041 11.32 11.239v4.683c0 1.1-.9 1.993-2.008 1.993a2 2 0 0 1-2.007-1.993v-4.683c0-3.999-3.278-7.253-7.305-7.253h-1.691a7.256 7.256 0 0 0-3.37.837c2.516 2.491 4.075 5.933 4.075 9.73v4.759A2 2 0 0 1 25.686 47a2 2 0 0 1-2.008-1.993v-4.758c0-5.383-4.41-9.763-9.832-9.763-5.42 0-9.83 4.38-9.83 9.763v4.758A2 2 0 0 1 2.007 47 2 2 0 0 1 0 45.007v-4.758C0 32.667 6.211 26.5 13.846 26.5c2.284 0 4.434.56 6.335 1.537.107-.122.225-.237.365-.333a11.279 11.279 0 0 1 6.443-2.01h1.69zm-14.833-1.729c-6.655 0-12.07-5.376-12.07-11.984C1.777 5.375 7.192 0 13.847 0c3.098 0 5.918 1.175 8.058 3.087a10.589 10.589 0 0 1 5.93-1.8c5.866 0 10.64 4.739 10.64 10.563 0 5.826-4.774 10.565-10.64 10.565a10.74 10.74 0 0 1-5.762-1.687 12.062 12.062 0 0 1-8.226 3.238zm0-19.98c-4.442 0-8.055 3.587-8.055 7.996 0 4.41 3.613 7.998 8.055 7.998s8.054-3.588 8.054-7.998c0-4.409-3.612-7.996-8.054-7.996zm20.612 7.864c0-3.626-2.972-6.577-6.625-6.577-1.22 0-2.378.34-3.405.956a11.835 11.835 0 0 1 1.488 5.753c0 2.008-.506 3.896-1.388 5.56 1 .576 2.124.887 3.305.887 3.653 0 6.625-2.951 6.625-6.579z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconGuest;
